/* 司馬懿傳・第 4 章：高平陵（正始九年～嘉平元年，248–249）
 * 史實：《晉書·宣帝紀》正始八年「帝稱疾不與政事」。九年「會河南尹李勝將莅荊州，來候帝。帝詐疾篤，使兩婢侍，持衣衣落，指口言渴，
 *       婢進粥，帝不持杯飲，粥皆流出霑胸。……勝曰：『當還忝本州，非并州。』帝乃錯亂其辭曰：『君方到并州。』……
 *       勝退告爽曰：『司馬公尸居餘氣，形神已離，不足慮矣。』」（同事又見《三國志·曹爽傳》注引《魏末傳》）
 *       嘉平元年「春正月甲午，天子謁高平陵，爽兄弟皆從。是日，太白襲月。帝于是奏永寧太后廢爽兄弟。時景帝為中護軍，將兵屯司馬門。
 *       帝列陣闕下，經爽門。爽帳下督嚴世上樓，引弩將射帝，孫謙止之曰：『事未可知。』三注三止，皆引其肘不得發。
 *       大司農桓範出赴爽，蔣濟言於帝曰：『智囊往矣。』帝曰：『爽與範內疏而智不及，駑馬戀短豆，必不能用也。』
 *       於是假司徒高柔節，行大將軍事，領爽營……命太僕王觀行中領軍，攝羲營。帝親帥太尉蔣濟等勒兵出迎天子，屯于洛水浮橋」；
 *       「爽不通奏，留車駕宿伊水南，伐樹為鹿角……桓範果勸爽奉天子幸許昌……爽不能用，而夜遣侍中許允、尚書陳泰詣帝，觀望風旨。
 *       帝數其過失，事止免官。……帝又遣爽所信殿中校尉尹大目諭爽，指洛水為誓，爽意信之。桓範等援引古今，諫說萬端。終不能從，
 *       乃曰：『司馬公正當欲奪吾權耳。吾得以侯還第，不失為富家翁。』範拊膺曰：『坐卿，滅吾族矣！』遂通帝奏。」
 *       （「駑馬戀棧豆」在《曹爽傳》注引干寶《晉紀》是蔣濟說的；「以洛水為誓」見注引《世語》；「富家翁」見注引《魏氏春秋》。）
 * 流程：第一段「等」——臥病在床，李勝來探：躺著不動、照著演，動一下李勝就起疑 →
 *       第二段「快」——正月甲午曹爽出城：奏太后、經爽門（樓上嚴世的弩三注三止，別在樓下逗留）、假節領爽營與羲營、屯洛水浮橋，
 *       都要在曹爽回過神之前做完；桓範從平昌門奔爽 →
 *       第三段「等」——守在浮橋，不渡洛水：派許允、陳泰去，再派尹大目去，在洛水邊指水為誓，曹爽的決心一點點垮掉，遂通帝奏。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick } from '../kit.ts';
import { MEN, walkTo, flag, bed, night } from './simayi_kit.ts';
import { HOME, BED, PALACE, SIMAMEN, SHUANG, TOWER, SHUANG_YING, XI_YING, PINGCHANG, JINYANG, BRIDGE, CAO, YI_Y } from '../maps/simayi_luoyang.ts';

const LV = 15, DEADLINE = 160, AWAY_MAX = 8;
const DOOR = [HOME[0] - 700, HOME[1] + 320], SEAT = [BED[0] - 150, BED[1] + 40];
const HOLD = [BRIDGE[0], BRIDGE[1] - 260], OATH = [BRIDGE[0] + 420, BRIDGE[1] - 230];
// 詐病的四段：每段躺著不動演完
const ACTS = [
  ['持衣衣落', [['李勝', '勝將莅荊州，特來拜辭太傅。'], ['婢', '（為太傅披衣，衣從肩上滑落）']]],
  ['指口言渴', [['司馬懿', '（指口）……渴……'], ['婢', '（進粥）'], ['李勝', '……粥都流出來了。眾情謂明公舊風發動，何意尊體乃爾！']]],
  ['氣息纔屬', [['司馬懿', '年老枕疾，死在旦夕。君當屈并州，并州近胡，善為之備。恐不復相見，以子師、昭兄弟為託。'], ['李勝', '當還忝本州，非并州。']]],
  ['錯亂其辭', [['司馬懿', '君方到并州。'], ['李勝', '當忝荊州。'], ['司馬懿', '年老意荒，不解君言。今還為本州，盛德壯烈，好建功勳！']]],
];

export default {
  id: 'simayi-4', map: 'simayi_luoyang', hero: 'simayi', gold: 0,
  title: '第 4 章　高平陵', year: '正始九年（248）～嘉平元年（249）',
  brief: {
    quote: [{ text: '司馬公尸居餘氣，形神已離，不足慮矣。', src: '李勝告曹爽，《晉書·宣帝紀》' }, { text: '吾得以侯還第，不失為富家翁。', src: '曹爽，《晉書·宣帝紀》' }],
    text: '明帝臨終，託司馬懿與大將軍曹爽共同輔政。曹爽任用何晏、鄧颺、丁謐，把太后遷到永寧宮，兄弟都掌禁兵。司馬懿七十歲，稱病在家，不問政事，等了將近兩年。',
    goals: ['李勝來探病：躺著不動，演到他信', '正月甲午，曹爽奉天子出城：奏太后、經爽門、領爽營羲營、屯洛水浮橋', '守在浮橋：派人說服曹爽'],
  },
  words: { ally: '司馬家兵', foe: '曹爽兵' },
  stars: [
    { text: '李勝一點都沒起疑', ok: (m) => !m.vars.susMax || m.vars.susMax < 1 },
    { text: '經爽門時沒有讓嚴世的弩真正射出', ok: (m) => !m.vars.shot },
    { text: '甲午那天 100 秒內屯洛水浮橋', ok: (m) => m.vars.bridgeT != null && m.vars.bridgeT <= 100 },
  ],
  steps: [
    { // 0. 詐病：李勝來候
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = BED[0]; me.y = BED[1];
        V.sus = 0; V.susMax = 0; V.act = 0; V.night = true;
        m.folk(BED[0], BED[1] + 12, { name: '床', still: true, near: 1, draw: bed });
        V.maids = [[-60, 70], [70, 70]].map(([dx, dy]) => m.folk(BED[0] + dx, BED[1] + dy, { name: '婢', still: true, near: 1, look: 2 }));
        V.li = m.folk(DOOR[0], DOOR[1], { name: '李勝', still: true, near: 1, look: 3 });
        m.card('帝稱疾不與政事。時人為之謠曰：「何、鄧、丁，亂京城。」', '《晉書·宣帝紀》');
        m.after(4, () => m.line('提示', '曹爽派李勝來探虛實。待在床上不動，司馬懿會一段段演下去；一動、一出手，李勝就會起疑。'));
        m.obj('feign', '詐疾篤：躺在床上不動');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        if (!V.arrived) { if (w.t > 6 && walkTo(V.li, SEAT[0], SEAT[1], 90, dt)) { V.arrived = true; V.li.f = 1; } return false; }
        const inBed = SG.gd(me.x, me.y, BED[0], BED[1]) < 90;
        if (!inBed || me.act) V.sus = Math.min(100, V.sus + dt * 45);
        V.susMax = Math.max(V.susMax, V.sus);
        m.get('feign').text = `詐疾篤：躺在床上不動（${ACTS[Math.min(V.act, 3)][0]}・李勝的疑心 ${Math.floor(V.sus)}%）`;
        if (V.sus >= 100) { m.lose('李勝看出了破綻'); return false; }
        if (V.act < ACTS.length && !V.talking) {
          const [label, lines] = ACTS[V.act];
          m.chanAt(me, 'act' + V.act, BED[0], BED[1], 90, 4, label, () => {
            V.talking = true;
            lines.forEach((L, i) => m.after(i * 2.2, () => m.line(L[0], L[1])));
            m.after(lines.length * 2.2, () => { V.act++; V.talking = false; });
          }, { hurt: false, fail: () => { V.sus = Math.min(100, V.sus + 25); m.line('李勝', '（……太傅剛才是不是動了？）'); } });
        }
        return V.act >= ACTS.length;
      },
    },
    { // 1. 正月甲午：快
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('feign');
        m.card('勝退告爽曰：「司馬公尸居餘氣，形神已離，不足慮矣。」故爽等不復設備。', '《晉書·宣帝紀》');
        m.folks = m.folks.filter((f) => f !== V.li);
        m.after(5, () => {
          V.night = false; V.t1 = w.t;
          m.big('嘉平元年正月甲午');
          m.card('天子謁高平陵，爽兄弟皆從。是日，太白襲月。', '《晉書·宣帝紀》');
          me.x = HOME[0] - 300; me.y = HOME[1] + 260;
          V.men = Array.from({ length: 6 }, (_, i) => { const u = m.recruit(me.x - 80 - (i % 3) * 50, me.y + 60 + Math.floor(i / 3) * 60, '家兵'); u.hp = u.maxHp = 700; m.join(u, me); return u; });
          m.line('司馬懿', '（起身）……更衣。去永寧宮。');
          m.obj('go', '');
          m.obj('palace', '奏永寧太后廢爽兄弟');
          m.obj('ying', '假節領爽營、攝羲營', 2);
          m.obj('bridge', '屯洛水浮橋');
          m.mark('palace', PALACE[0], PALACE[1], '永寧宮');
          m.mark('sy', SHUANG_YING[0], SHUANG_YING[1], '爽營', true); m.mark('xy', XI_YING[0], XI_YING[1], '羲營', true);
          V.ying = 0; V.yan = { t: 0, n: 0, cd: 1.5 };
          m.after(25, () => { // 桓範出平昌門
            V.fan = m.folk(2700, 2300, { name: '桓範', still: true, near: 1, look: 1 }); V.fanI = 0;
            m.line('蔣濟', '智囊往矣。');
            m.after(3, () => m.line('司馬懿', '爽與範內疏而智不及，駑馬戀短豆，必不能用也。'));
          });
        });
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        if (V.t1 == null) return false;
        const t = w.t - V.t1;
        m.get('go').text = `趁曹爽回過神之前（${Math.max(0, Math.ceil(DEADLINE - t))} 秒）`;
        if (t > DEADLINE) { m.lose('曹爽得知城中有變，羲營、爽營閉門自守'); return false; }
        // 永寧宮
        if (!V.palace) m.chanAt(me, 'palace', PALACE[0], PALACE[1], 170, 1.5, '奏太后', () => {
          V.palace = true; m.done('palace'); m.unmark('palace');
          m.card('帝于是奏永寧太后廢爽兄弟。時景帝為中護軍，將兵屯司馬門。', '《晉書·宣帝紀》');
          V.shi = ally(w, MEN.simashi, SIMAMEN[0] + 60, SIMAMEN[1] + 120, LV - 2); V.shi.hold = [SIMAMEN[0], SIMAMEN[1] + 120];
        });
        // 爽營、羲營
        for (const [k, p, who, text] of [['sy', SHUANG_YING, '高柔', '假司徒高柔節，行大將軍事，領爽營。'], ['xy', XI_YING, '王觀', '命太僕王觀行中領軍，攝羲營。']]) {
          if (V[k]) continue;
          m.chanAt(me, k, p[0], p[1], 200, 1.5, '假節', () => {
            V[k] = true; V.ying++; m.prog('ying', V.ying); m.unmark(k);
            m.folk(p[0] + 60, p[1] - 40, { name: who, still: true, near: 1, draw: flag, text: who[0], col: '#3a2a5a' });
            m.line('司馬懿', k === 'sy' ? '君為周勃矣。' : '王太僕，羲營交給你。');
            m.card(text, '《晉書·宣帝紀》');
          });
        }
        // 爽門：嚴世上樓引弩
        const nearTower = SG.gd(me.x, me.y, TOWER[0], TOWER[1]) < 650;
        if (nearTower && !V.passed) {
          V.yan.cd -= dt;
          if (V.yan.cd <= 0) {
            V.yan.cd = 3;
            const n = ++V.yan.n;
            if (n === 1) m.line('嚴世', '（上樓，引弩）');
            m.warn({ x: me.x, y: me.y, r: 100, t: 1.4, col: '#ff5040', fn: (hit) => {
              if (n <= 3) { m.line('孫謙', '事未可知。'); w.fx({ k: 'puff', x: TOWER[0], y: TOWER[1] }); return; }
              V.shot = true; m.line('嚴世', '放！');
              for (const u of hit) if (u.team === 0) m.hurt(u, 380, 1);
            } });
          }
        }
        if (!V.passed && V.yan.n > 0 && !nearTower && me.y > SHUANG[1] + 200) { V.passed = true; if (!V.shot) m.card('爽帳下督嚴世上樓，引弩將射帝，孫謙止之曰：「事未可知。」三注三止，皆引其肘不得發。', '《晉書·宣帝紀》'); }
        // 桓範：出平昌門往南奔爽
        if (V.fan && V.fanI < 3) { const P = [[2700, 2900], [PINGCHANG[0], PINGCHANG[1] + 200], [2300, 4200]][V.fanI]; if (walkTo(V.fan, P[0], P[1], 170, dt)) V.fanI++; }
        if (V.fan && V.fanI >= 3 && !V.fanGone) { V.fanGone = true; m.folks = m.folks.filter((f) => f !== V.fan); }
        // 浮橋
        const ready = V.palace && V.ying >= 2;
        if (ready && !V.bm) { V.bm = true; m.mark('bridge', HOLD[0], HOLD[1], '洛水浮橋'); }
        if (!ready || !m.near(me, HOLD[0], HOLD[1], 220)) return false;
        V.bridgeT = t;
        return true;
      },
    },
    { // 2. 屯于洛水浮橋：等曹爽自己垮
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('bridge'); m.done('go'); m.unmark('bridge');
        m.card('帝親帥太尉蔣濟等勒兵出迎天子，屯于洛水浮橋。', '《晉書·宣帝紀》');
        V.resolve = 100; V.away = 0; V.fanT = 6;
        for (let i = -3; i <= 3; i++) m.gate('lu' + i, CAO[0] + i * 160, YI_Y + 260, 90, 'abatis'); // 伐樹為鹿角
        V.shuang = m.folk(CAO[0], CAO[1] - 120, { name: '曹爽', still: true, near: 1, look: 0 });
        V.fan2 = m.folk(CAO[0] + 120, CAO[1] - 100, { name: '桓範', still: true, near: 1, look: 1 });
        V.guard = Array.from({ length: 6 }, (_, i) => { const u = m.foe('huangjin', CAO[0] - 300 + i * 120, YI_Y + 400, { spec: SG.SOLDIERS.wei, name: '屯兵', hp: 700, maxHp: 700, atk: 30 }); u.asleep = true; return u; });
        m.after(3, () => m.card('爽不通奏，留車駕宿伊水南，伐樹為鹿角，發屯兵數千人以守。桓範果勸爽奉天子幸許昌，移檄徵天下兵。', '《晉書·宣帝紀》'));
        m.after(7, () => m.line('提示', '守在浮橋北頭，不要渡洛水，也不要離開太久。派人去伊水南說服曹爽；桓範會一直勸他。'));
        m.after(8, () => { V.envoys = m.folk(HOLD[0] - 160, HOLD[1] + 20, { name: '許允、陳泰', still: true, near: 140, look: 3, lines: [['司馬懿', '告訴大將軍：事止免官。'], ['許允', '是。']], onHeard: (f) => { f.go = 1; } }); m.mark('env', HOLD[0] - 160, HOLD[1] + 20, '許允、陳泰', true); });
        m.obj('resolve', '');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        // 不能渡洛水、不能走開
        if (me.y > BRIDGE[1] + 180) { m.lose('兵向天子車駕：師出無名'); return false; }
        if (SG.gd(me.x, me.y, HOLD[0], HOLD[1]) > 900) { V.away += dt; if (V.away > AWAY_MAX) { m.lose('離開浮橋太久，曹爽奉天子幸許昌'); return false; } } else V.away = Math.max(0, V.away - dt);
        // 桓範諫說萬端
        if (V.oath) V.resolve -= dt * 3; // 爽意信之：桓範再怎麼說也沒用了
        if ((V.fanT -= dt) <= 0) { V.fanT = 7; if (!V.oath) V.resolve = Math.min(100, V.resolve + 5); m.line('桓範', ['今日卿門戶求貧賤復可得乎？', '奉天子幸許昌，移檄徵天下兵，誰敢不應！', '匹夫持質一人，尚欲望活，今卿與天子相隨！'][Math.floor(SG.rand() * 3)]); }
        // 許允、陳泰：去了又回
        const E = V.envoys;
        if (E && E.go === 1) { m.unmark('env'); if (walkTo(E, CAO[0] - 200, CAO[1] - 160, 220, dt)) { E.go = 2; V.resolve -= 40; m.line('許允', '太傅說了，只是免官而已。'); m.line('陳泰', '大將軍，早自歸罪吧。'); } }
        if (E && E.go === 2 && walkTo(E, HOLD[0] - 160, HOLD[1] + 20, 220, dt)) {
          E.go = 3; m.line('陳泰', '大將軍還在猶豫。');
          V.yin = m.folk(HOLD[0] + 160, HOLD[1] + 20, { name: '尹大目', still: true, near: 140, look: 0, lines: [['司馬懿', '大目，你是曹爽信得過的人。'], ['尹大目', '太傅要我怎麼說？']], onHeard: (f) => { f.go = 1; m.line('提示', '尹大目到了伊水南，你就到洛水邊（地圖上的「指水為誓」）站 2 秒。'); } });
          m.mark('yin', HOLD[0] + 160, HOLD[1] + 20, '尹大目', true);
        }
        const Y = V.yin;
        if (Y && Y.go === 1) { m.unmark('yin'); if (walkTo(Y, CAO[0] + 200, CAO[1] - 160, 220, dt)) { Y.go = 2; Y.waitT = 12; m.mark('oath', OATH[0], OATH[1], '指水為誓'); m.line('尹大目', '太傅以洛水為誓，只是免官而已！'); } }
        if (Y && Y.go === 2) {
          Y.waitT -= dt;
          m.chanAt(me, 'oath', OATH[0], OATH[1], 160, 2, '指洛水為誓', () => { Y.go = 3; V.oath = true; V.resolve -= 60; m.unmark('oath'); m.card('帝又遣爽所信殿中校尉尹大目諭爽，指洛水為誓，爽意信之。', '《晉書·宣帝紀》'); });
          if (Y.go === 2 && Y.waitT <= 0) { Y.go = 4; m.unmark('oath'); m.line('曹爽', '……太傅自己為什麼不出來說？'); }
        }
        if (Y && Y.go >= 3 && walkTo(Y, HOLD[0] + 160, HOLD[1] + 20, 220, dt) && Y.go === 4) { Y.go = 0; Y.li = 0; Y.heard = false; m.mark('yin', Y.x, Y.y, '尹大目', true); } // 沒趕上：再派一次
        V.resolve = Math.max(0, V.resolve);
        m.get('resolve').text = `屯洛水浮橋，等曹爽通奏（曹爽的決心 ${Math.ceil(V.resolve)}%）`;
        return V.resolve <= 0;
      },
    },
    { // 3. 遂通帝奏
      enter(m, w) {
        m.done('resolve');
        m.line('曹爽', '司馬公正當欲奪吾權耳。吾得以侯還第，不失為富家翁。');
        m.after(3, () => m.line('桓範', '坐卿，滅吾族矣！'));
        m.after(6, () => m.card('終不能從，乃曰：「司馬公正當欲奪吾權耳。吾得以侯還第，不失為富家翁。」範拊膺曰：「坐卿，滅吾族矣！」遂通帝奏。', '《晉書·宣帝紀》'));
        m.after(12, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    if (!w.player.alive) { m.lose('司馬懿遇害'); return; }
    if (m.vars.shi) allyTick(w, m.vars.shi, null, 300);
  },
  overlay(ctx, m, view, x0, y0, vw, vh) { if (m.vars.night) night(ctx, x0, y0, vw, vh, 0.35); },
};
